import { client } from "./axios";
import { PaymentResponseDto } from "../types/Payment";
import { CONFIG } from "../config";
import {TBankRecurentStatusDto } from "@/types/TBankRecurentStatus";

const paymentApi = {
    createPayment: async (duration: number, isRecurrent: boolean): Promise<string | null> => {
        const url = `/payment/tbank`;
        const data = { 
             duration: duration,
             isRecurrent: isRecurrent,
             redirectUrl: CONFIG.currentUrl
            };

        try {
            const response = await client.post<PaymentResponseDto>(url, data);
            const responseData = response.data;
            
            if (responseData.Success && responseData.PaymentURL) {
                return responseData.PaymentURL;
            } else {
                return null;
            }
        } catch (error) {
            console.error("Ошибка:", error);
            return null;
        }
    },

    getTBankPaymentRecurrent: async (): Promise<TBankRecurentStatusDto> => {
        const url = `/payment/tbank/recurrent`;
        const response = await client.get<TBankRecurentStatusDto>(url);
        return response.data;
    },

    cancelRecurrent: async () => {
        const url = `/payment/tbank/cancel`;
        const response = await client.post(url);
        return response.status;
    }
}

export default paymentApi;